<template>
  <Modal
    :show="true"
    centered
    size="fluid"
    title="Comprobante"
    @hide="$emit('hide', flags.reload)"
  >
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Comprobante2
        :initialModo="comprobante.modo"
        :initialSerie="containers.initialSerie"
        :initialNota="containers.initialNota"
        :initialComprobante="containers.initialComprobante"
        :initialCliente="containers.initialCliente"
        :initialItems="containers.items"
        :initialAnulado="containers.initialAnulado"
        :facturado="containers.facturado"
        @facturar="onFacturar"
      ></Comprobante2>
    </template>
  </Modal>
</template>

<script>
import Spinner from "../../shared/components/Spinner.vue";
import Comprobante2 from "../../comprobantes/components/Comprobante2.vue";
import Modal from "../../shared/components/Modal.vue";

export default {
  components: { Modal, Comprobante2, Spinner },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    comprobante: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: {
        view: true
      },
      containers: {
        initialSerie: "",
        initialNota: {},
        initialComprobante: {},
        initialCliente: {},
        initialAnulado: {},
        facturado: null,
        items: []
      },
      flags: {
        reload: false
      }
    };
  },
  async created() {
    try {
      const response = await this.axios.get(
        `/comprobantes/${this.comprobante.idComprobante}`
      );

      const comprobante = response.data.content;

      this.containers.initialComprobante = {
        id: comprobante.idComprobante,
        tipoDoc: comprobante.idDocVenta,
        numeroDoc: comprobante.nroComprobante,
        fechaEmision: comprobante.fecha,
        transaccion: comprobante.idTransaccion,
        moneda: comprobante.idMoneda,
        tipoPago: comprobante.idPagoTipo,
        pagoDias: comprobante.diasCredito || "",
        observaciones: comprobante.observaciones || "",
        emitirNota: this.comprobante.emitirNota
      };

      this.containers.initialCliente = {
        agencia: comprobante.idAgencia || 0,
        denominacion: comprobante.denominacion,
        tipoDoc: comprobante.tipoDocumento,
        numeroDoc: comprobante.nroDocumento,
        direccion: comprobante.direccion,
        email: comprobante.email || ""
      };

      this.containers.items = [...comprobante.items];

      this.containers.facturado = {
        enlaceComprobante: comprobante.enlace,
        enlacePdf: comprobante.enlacePdf,
        enlaceXml: comprobante.enlaceXml,
        enlaceCdr: comprobante.enlaceCdr,
        numeroDoc: comprobante.nroComprobante,
        qr: comprobante.cadenaQr,
        serie: comprobante.serie,
        totalLetras: comprobante.totalLetras
      };

      if (this.estaAnulado(comprobante)) {
        this.containers.initialAnulado = {
          fecha: comprobante.fechaAnulacion,
          motivo: comprobante.motivoAnulacion,
          author: comprobante.usuarioAnulacion
        };
      }

      const isNota = this.isNota(comprobante);

      if (isNota) {
        const isNotaCredito = this.isNotaCredito(comprobante);

        this.containers.initialNota = {
          tipoDoc: comprobante.idDocVenta,
          tipoNota: isNotaCredito
            ? comprobante.idNotaCreditoTipo
            : comprobante.idNotaDebitoTipo,
          numeroDoc: comprobante.nroComprobante,
          esNota: true
        };

        this.containers.initialComprobante = {
          tipoDoc: comprobante.tipoModificado,
          numeroDoc: comprobante.numeroModificado
        };
      }

      if (this.comprobante.emitirNota) {
        this.containers.facturado = {};
      }

      this.containers.initialSerie = comprobante.serie;

      this.loading.view = false;
    } catch (error) {}
  },
  methods: {
    estaAnulado: comprobante => !!comprobante.fechaAnulacion,
    isNota: comprobante => comprobante.idDocVenta > 2,
    isNotaCredito: comprobante => comprobante.idDocVenta == 3,
    onFacturar() {
      this.flags.reload = true;
    }
  }
};
</script>
